<div class="message-toast-stack" *ngIf="toasts.length">
  <div
    *ngFor="let toast of toasts"
    class="message-toast"
    [class.leaving]="toast.leaving"
    [style.--accent]="channelMeta[toast.channel].accent"
    (click)="open(toast)"
  >
    <div class="message-toast-icon">
      <i class="bi" [ngClass]="channelMeta[toast.channel].icon"></i>
    </div>
    <div class="message-toast-body">
      <div class="message-toast-header">
        <span class="message-toast-channel">{{ channelMeta[toast.channel].label }}</span>
        <button type="button" class="message-toast-close" (click)="dismiss(toast.id); $event.stopPropagation()">
          <i class="bi bi-x"></i>
        </button>
      </div>
      <div class="message-toast-title">{{ toast.title }}</div>
      <div class="message-toast-preview">{{ toast.preview }}</div>
      <div class="message-toast-actions" *ngIf="toast.channel === 'sms' && toast.address">
        <span class="message-toast-cta"><i class="bi bi-reply-fill"></i> Reply</span>
        <button type="button" class="message-toast-link" (click)="openInbox(toast, $event)">Open in Messages</button>
      </div>
    </div>
  </div>
</div>
